import {
  PlatformType,
  DD_MATCH_PLATFORM_FEE_PERCENT,
  DD_TOURNAMENT_PLATFORM_FEE_PERCENT,
  COLYSEUS_MATCH_PLATFORM_FEE_PERCENT,
  LICHESS_TOURNAMENT_PLATFORM_FEE_PERCENT,
  LOL_TOURNAMENT_PLATFORM_FEE_PERCENT,
  EV_IO_TOURNAMENT_PLATFORM_FEE_PERCENT,
  PAPERGAMES_TOURNAMENT_PLATFORM_FEE_PERCENT,
} from '@okletsplay/core';
import { gamesSelectorFactory } from 'modules/games/store/games/selectors';
import { useSelector } from 'react-redux';

export const useTournamentPlatformFeePercentage = (gameId?: string) => {
  const platformType = useSelector(gamesSelectorFactory.useById(gameId as string))?.platformType;

  let platformFeePercentage: number;
  switch (platformType) {
    case PlatformType.LeagueOfLegends:
      platformFeePercentage = LOL_TOURNAMENT_PLATFORM_FEE_PERCENT;
      break;
    case PlatformType.Olp:
      platformFeePercentage = DD_TOURNAMENT_PLATFORM_FEE_PERCENT;
      break;
    case PlatformType.Colyseus:
    case PlatformType.BubbleUpEndless:
      platformFeePercentage = COLYSEUS_MATCH_PLATFORM_FEE_PERCENT;
      break;
    case PlatformType.Lichess:
      platformFeePercentage = LICHESS_TOURNAMENT_PLATFORM_FEE_PERCENT;
      break;
    case PlatformType.EvIo:
      platformFeePercentage = EV_IO_TOURNAMENT_PLATFORM_FEE_PERCENT;
      break;
    case PlatformType.Papergames:
      platformFeePercentage = PAPERGAMES_TOURNAMENT_PLATFORM_FEE_PERCENT;
      break;
    default:
      platformFeePercentage = 0;
  }

  return { platformFeePercentage };
};

export const useMatchPlatformFeePercentage = () => {
  return { platformFeePercentage: DD_MATCH_PLATFORM_FEE_PERCENT };
};
